import React, { Component } from 'react';
import PropTypes from 'prop-types';
import styled from 'styled-components';
import { media } from 'styled-bootstrap-grid';

import { injectTranslations } from '@lang';
import { parseToUnified } from '@utils/helpers';
import WrappedSlider from '@common/components/WrappedSlider';
import SuggestionItem from '@common/components/SuggestionItem';
import SectionContainer from '@common/components/SectionContainer';
import SectionHeader from '@common/components/SectionHeader';

const SLIDER_ITEM_WIDTH = 314;

const FullwidthSection = styled(SectionContainer)`
  max-width: 100%;
  background: ${({ theme }) => theme.customColors.tertiary};
  padding-top: 54px;
  padding-bottom: 54px;
`;

const Header = styled(SectionHeader)`
  font-size: 22px;
  text-transform: none;
  margin-bottom: 1em;
  text-align: left;

  ${media.sm`
    text-align: center;
    font-size: 28px;
  `}
`;

const SliderWrapper = styled.section`
  position: relative;
  ${media.md`
    width: ${({ quantity }) => quantity * SLIDER_ITEM_WIDTH}px;
  `}

  max-width: 100%;
  margin: 0 auto;

  .slick-initialized .slick-track {
    display: flex;

    .slick-slide {
      display: flex;
      height: inherit !important;
      align-items: stretch;
      justify-content: stretch;
    }
  }
`;

class OtherProductsSection extends Component {
  constructor(props) {
    super(props);
    this.state = {
      dragging: false,
    };
  }

  render() {
    const { items, leadingCategoryId, t } = this.props;
    const { dragging } = this.state;

    // handle backend errors like cross sell objects w/o name
    const filteredItems = items.filter(({ object }) => !!object?.name);

    if (!filteredItems.length) {
      return null;
    }

    return (
      <FullwidthSection>
        <Header>{t('product.otherProducts.title')}</Header>
        <SliderWrapper quantity={filteredItems.length}>
          <WrappedSlider
            speed={300}
            variableWidth
            draggable={false}
            beforeChange={() => this.setState({ dragging: true })}
            afterChange={() => this.setState({ dragging: false })}
          >
            {filteredItems.map(({ type, object }) => (
              <SuggestionItem
                key={`${type}-${object.id}`}
                {...parseToUnified(type, object)}
                isFullHeight
                onClick={(e) => {
                  if (dragging) {
                    e.preventDefault();
                  }
                }}
                leadingCategoryId={leadingCategoryId}
              />
            ))}
          </WrappedSlider>
        </SliderWrapper>
      </FullwidthSection>
    );
  }
}

OtherProductsSection.propTypes = {
  items: PropTypes.arrayOf(
    PropTypes.shape({
      type: PropTypes.string,
      object: PropTypes.object,
    })
  ).isRequired,
  leadingCategoryId: PropTypes.number,
  t: PropTypes.func.isRequired,
};

OtherProductsSection.defaultProps = {
  leadingCategoryId: null,
};

export default injectTranslations(OtherProductsSection);
